import { render, staticRenderFns } from "./forgetEmail.vue?vue&type=template&id=6d94f763&scoped=true"
import script from "./forgetEmail.vue?vue&type=script&lang=js"
export * from "./forgetEmail.vue?vue&type=script&lang=js"
import style0 from "./forgetEmail.vue?vue&type=style&index=0&id=6d94f763&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94f763",
  null
  
)

export default component.exports